import { storeToRefs } from 'pinia'
import useMedcardStore from '~/stores/useMedcardStore'
import useProfileStore from '~/stores/useProfileStore'

export const useConfirmEmail = () => {
  const profileStore = useProfileStore()
  const { email: storeEmail } = storeToRefs(profileStore)
  const medcardStore = useMedcardStore()
  const { masterToken: masterMedcardToken } = storeToRefs(medcardStore)

  return {
    storeEmail,
    masterMedcardToken,
  }
}
